import WHOLESALE_ZONES from './zones.graphql'

export default WHOLESALE_ZONES
